import type { StaticMediaData } from '@monogrid/vue-boost/core'

import src from '@/assets/images/menu/gg.jpg'

export default {
  src,
  ext: 'jpg',
  width: 1200,
  height: 800,
  color: '#597483'
} as StaticMediaData
